//import liraries

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";



// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      width: 1003,
      height: 425,
      marginTop: 30,
      marginLeft: 30,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginBottom: 30,
    },
    backIconViewStyle: {
      flexDirection: "row",
      margin: 10,
    },
    btnWidget:{
      width: 107,
      height: 26.3,
      alignSelf: "flex-end",
    },
    linkText:{
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: -0.24,
      textAlign: "left",
      color: "#ffffff",
    },
    backIconStyle: {
      width: 19,
      height: 19,
      resizeMode: "center",
    },
    viewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    viewStyle1:{
        flexDirection: "row",
        flexWrap:"wrap",
        marginTop: 10,
        justifyContent:"center",
      },
    contentViewStyle: {
      flexDirection: "row",
      justifyContent: "space-around",
      marginHorizontal: 30,
    },
    cardViewStyle: {
      width: 343.8,
      height: 130,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#cccccc",
      borderRadius: 10,
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 10,
    },
    cardCreditStyle:{
      width: 280,
      height: 81.8,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      borderRadius: 10,
      padding: 10,
      margin: 10,
    },
    textInputStyle: {
      width: 343.8,
      height: 32.5,
      borderRadius: 8.3,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0.1,
      textAlign: "left",
      color: "#b6b7bf",
      paddingLeft: 10,
    },
    paymentMethodViewStyle: {
      width: 329,
      height: 30,
      borderRadius: 7,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "rgba(204, 208, 213, 0.8)",
      marginVertical: 5,
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 10,
      justifyContent: "space-between",
    },
    secondViewStyle: {
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    updateButtonStyle: {
      width: 132,
      height: 36,
    },
    cardWidget:{
      flexDirection: "row",
      justifyContent: "space-evenly",
      flex:1
    },
    footerWidget:{
      width: 123.5,
      height: 36,
      alignSelf: "center",
      marginTop: 20,
    },
    creditCardWidget:{
      width: 280,
      height: 81.8,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      borderRadius: 10,
      padding: 10,
      marginTop: 10,
    },
    editLink:{
        position: "absolute",
        zIndex: 999,
        right: 10,
        top: 8,
    },
    vehicleImageStyle: {
      width: 71.2,
      height: 65.8,
      resizeMode: "center",
    },
    viewVehicleTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      paddingLeft: 15,
    },
    userDetailsKeyTextStyle: {
      opacity: 0.51,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 20,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    headingTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "500",
      fontStyle: "normal",
      letterSpacing: 0.3,
      textAlign: "left",
      color: "#5f5f5f",
      paddingBottom: 5,
    },
    quickAddButtons: {
      flexDirection: "row",
      marginLeft: -10,
      paddingTop: 10,
    },
    quickAddButton: {
      width: 65,
      height: 23.5,
      backgroundColor: "#ffdfe2",
      borderRadius: 12,
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 8.8,
    },
    qabInnerText: {
      fontFamily: "Inter",
      fontSize: 10,
      color: "#9b1e27",
    },
    cardSpace:{
      flexDirection: "row",
      justifyContent: "space-between",
    },
    paymentMethodTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    creditOverlay: {
      width: "70%",
      height: 300,
      overflow:"scroll",
      alignItems: "center",
      backgroundColor: "white",
      borderRadius: 15,
    },
    loaderBg: {
      backgroundColor: "white",
      width: "70%",
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    overlayContentViewStyle: {
      width: 348.1,
      height: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    enterOtpTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 21,
      letterSpacing: 0.64,
      textAlign: "center",
      color: "#66625f",
      paddingTop: 20,
    },
    otpDescTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 10,

      marginHorizontal: 30,
    },
    otpInputViewStyle: {
      width: 250.4,
      height: 38,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 1.5,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 3.6,
      textAlign: "left",
      color: "#66625f",
      borderRadius: 5,
      marginTop: 20,
      alignSelf: "center",
      paddingLeft: 10,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
      marginTop: 5,
    },
    timerTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bd2d37",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        width: 800,
        borderRadius: 15,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        height: 649,
        width: "95%",
        borderRadius: 15,
      },
      viewStyle1:{
        flexDirection: "column",
      },
      contentViewStyle: {
        flexDirection: "column",
        justifyContent: "space-around",
        marginHorizontal: 30,
        alignItems: "center",
      },
      secondViewStyle: {
        marginTop: 20,
      },
      updateButtonStyle: {
        alignSelf: "flex-end",
        marginRight: "20%",
        marginTop: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: 528,
        height: 649,
        borderRadius: 15,
      },
      viewStyle1:{
        flexDirection: "column",
      },
      contentViewStyle: {
        flexDirection: "column",
        justifyContent: "space-around",
        marginHorizontal: 30,
      },
      cardViewStyle: {
        width: 274.8,
        height: 130,
      },
      userDetailsKeyTextStyle: {
        fontSize: 10,
      },
      headingTextStyle: {
        fontSize: 14,
      },
      textInputStyle: {
        width: 274.8,
      },
      paymentMethodViewStyle: {
        width: 274.8,
      },
      secondViewStyle: {
        marginTop: 20,
      },
      updateButtonStyle: {
        alignSelf: "flex-end",
        marginTop: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: 322.9,
        height: 638,
        borderRadius: 20,
        marginLeft:0
      },
      viewStyle1:{
        flexDirection: "column",
      },
      contentViewStyle: {
        flexDirection: "column",
        justifyContent: "space-around",
        marginHorizontal: 30,
      },
      cardViewStyle: {
        width: 274.8,
        height: 130,
      },
      userDetailsKeyTextStyle: {
        fontSize: 10,
      },
      headingTextStyle: {
        fontSize: 14,
      },
      textInputStyle: {
        width: 274.8,
      },
      paymentMethodViewStyle: {
        width: 274.8,
      },
      secondViewStyle: {
        marginTop: 20,
      },
      updateButtonStyle: {
        alignSelf: "flex-end",
        marginTop: 20,
      },
      cardCreditStyle:{
        width: 230,
      },
      creditOverlay: {
        width: "90%",
        height: 400,
      },
      containerBorder: {
        width: 280,
        alignSelf:"center"
      },
    },
  }
);

//make this component available to the app
export default useStyles;
